export default "__VITE_PUBLIC_ASSET__d38def2e__"